import * as React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { TDispatch } from '../../../../redux';
import { reloadBetPosition } from '../../../../redux/reducers';
import { selectNeedBetPositionReload } from '../../../../selectors/betPosition';
import { selectNeedBetLeadersReload } from '../../../../selectors/topBets';
import { BetPositionError } from './BetPositionError';

export const BetPositionErrorContainer = () => {
  const needBetPositionReload = useSelector(selectNeedBetPositionReload);
  const needBetLeadersReload = useSelector(selectNeedBetLeadersReload);

  const dispatch = useDispatch<TDispatch>();

  const handleReloadClick = React.useCallback(() => {
    dispatch(reloadBetPosition());
  }, [dispatch]);

  /* Если нужно перезагрузить оба запроса ставок и позиций,
     рендерится одна кнопка "Попробовать снова" в блоке "Ставки лидеров" */
  if (!needBetPositionReload || needBetLeadersReload) {
    return null;
  }

  return <BetPositionError onReloadClick={handleReloadClick} />;
};
